<template>
  <div class="min-h-screen bg-slate-50 font-sans">
    <header class="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div class="flex items-center gap-8">
          <!-- Logo/Text -->
          <NuxtLink to="/" class="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="ClaimReady" class="h-8 w-auto">
          </NuxtLink>

          <!-- Desktop Nav -->
          <nav class="hidden md:flex items-center gap-6">
            <a href="/#features"
              class="text-sm font-medium text-slate-600 hover:text-primary transition-colors">Features</a>
            <a href="/#howItWorks" class="text-sm font-medium text-slate-600 hover:text-primary transition-colors">How
              it Works</a>
            <a href="/#advantage" class="text-sm font-medium text-slate-600 hover:text-primary transition-colors">Why
              ClaimReady</a>
            <a href="/#faq" class="text-sm font-medium text-slate-600 hover:text-primary transition-colors">FAQ</a>
          </nav>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-4">
          <NuxtLink v-if="inventoryStore.reports.length > 0" to="/#reports-section"
            class="text-sm font-medium text-slate-600 hover:text-primary">
            My Reports
          </NuxtLink>
          <UButton color="primary" variant="solid" label="Start Inventory" size="sm" class="hidden sm:inline-flex"
            @click="createNewReport" />
        </div>
      </div>
    </header>

    <main>
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { useInventoryStore } from '~/stores/inventory'

const inventoryStore = useInventoryStore()

const createNewReport = async () => {
  const reportId = await inventoryStore.createReport()
  navigateTo(`/reports/${reportId}`)
}
</script>
